import { Box } from '@mui/material';
import OsperbShorts from './elements/ShortPlayer';

const Section7 = () => {
    const reels = [
        {
            id: 1,
            thumbnail: '',
            videoUrl: 'https://youtube.com/shorts/tDIVzIORwPo',
            title: 'Chocochi',
            views: '1.2K',
        },
        {
            id: 2,
            thumbnail: '',
            videoUrl: 'https://youtube.com/shorts/IhedpEyxcsE',
            title: 'Focus motors',
            views: '890',
        },
        {
            id: 3,
            thumbnail: '',
            videoUrl: 'https://youtube.com/shorts/ZdXrLqJYqdA',
            title: 'Ideal reward',
            views: '1.8K',
        },
        {
            id: 4,
            thumbnail: '',
            videoUrl: 'https://youtube.com/shorts/M-zkV0DwpWQ',
            title: '',
            views: '3.1K',
        },
        {
            id: 5,
            thumbnail: '',
            videoUrl: 'https://youtube.com/shorts/XLkWQzB8oOA',
            title: '',
            views: '3.1K',
        },
    ];


    return (
        <Box className="small-shorts" >
            <OsperbShorts reels={reels} visibleItems={{ xs: 1.5, sm: 2.5, md: 6 }} />
        </Box>
    );
};

export default Section7; 